import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Spin } from "antd";
import withAdminLayout from "../../../layout/withAdminLayout";

const EmployeeDiscount = lazy(() =>
  import("../../../container/employeeDiscount/Index")
);
const EmployeeDiscountHistory = lazy(() =>
  import("../../../container/employeeDiscount/History")
);
const EmployeeDiscountHistoryDetails = lazy(() =>
  import("../../../container/employeeDiscount/HistoryDetails")
);
const PurchaseHistory = lazy(() =>
  import("../../../container/employeeDiscount/PurchaseHistory")
);

function EmployeeDiscountRoutes() {
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="dashboard" element={<EmployeeDiscount />} />
        <Route path="history" element={<EmployeeDiscountHistory />} />
        <Route path="history/:referenceId" element={<EmployeeDiscountHistoryDetails />} />
        <Route path="purchase_history" element={<PurchaseHistory />} />
        <Route path="*" element={<Navigate to="dashboard" />} />
      </Routes>
    </Suspense>
  );
}

export default withAdminLayout(EmployeeDiscountRoutes);
